var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-module"},[_c('member-module',{attrs:{"data":_vm.data && _vm.data.info}}),_c('my-form',{attrs:{"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }